module.exports = __webpack_public_path__ + "static/media/logout.355104c3.svg";